'use client';
import { AppBar, Box, IconButton, Link, Toolbar } from '@mui/material';
import React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import styles from './header-navbar.module.scss';
import SwipeableNavDrawer from '../nav-drawer/nav-drawer';
import { useTranslation } from 'react-i18next';
import LocaleSwitcher from '../LanguageSwitcher';
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';

export const linkActive = {
  '&.active': {
    textDecoration: 'underline rgb(156, 39, 176) solid 3px',
  },
  '&:hover': {
    backgroundColor: 'rgb(156, 39, 176)',
  },
  color: 'white',
  mx: 1,
  textAlign: 'left',
};

const HeaderNavbar = ({ headerText }: { headerText: string }) => {
  const pathname = usePathname();
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const toggleDrawer = (side: string, open: boolean) => {
    setState({ ...state, [side]: open });
  };
  return (
    <div className={styles.root}>
      <SwipeableNavDrawer toggleDrawer={toggleDrawer} open={state.left} />
      <AppBar position='static'>
        <Toolbar>
          <IconButton
            onClick={() => toggleDrawer('left', true)}
            edge='start'
            className={styles.menuButton}
            color='inherit'
            aria-label='menu'
          >
            <MenuIcon />
          </IconButton>
          <img src='/logo-3.svg' alt='logo' className={styles.logo} /> &nbsp;
          <Link
            component={NextLink}
            sx={{
              ...linkActive,
              fontSize: 24,
              '&:hover': {
                backgroundColor: '',
              },
            }}
            className={`${styles.title}`}
            href='/'
          >
            {headerText}
          </Link>
          <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
            <div style={{ display: 'flex' }}>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/'
                className={`${styles.link} ${pathname === '/' || pathname === `/${lang}` ? 'active' : ''}`}
              >
                {t('navbar.home.link.text')}
              </Link>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/quiz-options'
                className={`${styles.link} ${
                  pathname === '/quiz-options' || pathname?.startsWith(`/${lang}/quiz-options`) ? 'active' : ''
                }`}
              >
                {t('navbar.quiz-options.link.text')}
              </Link>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/learn-tables'
                className={`${styles.link} ${
                  pathname === '/learn-tables' || pathname?.startsWith(`/${lang}/learn-tables`) ? 'active' : ''
                }`}
              >
                {t('navbar.learn-tables.link.text')}
              </Link>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/practice'
                className={`${styles.link} ${
                  pathname === '/practice' || pathname?.startsWith(`/${lang}/practice`) ? 'active' : ''
                }`}
              >
                {t('navbar.start-quiz.link.text')}
              </Link>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/about'
                className={`${styles.link} ${
                  pathname === '/about' || pathname?.startsWith(`/${lang}/about`) ? 'active' : ''
                }`}
              >
                {t('navbar.about.link.text')}
              </Link>
              <Link
                component={NextLink}
                sx={linkActive}
                href='/help'
                className={`${styles.link} ${
                  pathname === '/help' || pathname?.startsWith(`/${lang}/help`) ? 'active' : ''
                }`}
              >
                {t('navbar.help.link.text')}
              </Link>
            </div>
          </Box>
          <LocaleSwitcher></LocaleSwitcher>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default HeaderNavbar;
